// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"4f91b27e","419":"33d1b8fc","774":"3b65c92d"}[chunkId] + ".chunk.js";
};